<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="title">
<p class="bk">Three for<br/>a Letter</p>
<br/>
<p class="bksub" style="text-align: center;">A John the Lord Chamberlain Mystery</p>
<p class="bkau">Mary Reed &amp; Eric Mayer</p>
<p class="bkau1"><a class="calibre1" href="http://www.home.earthlink.net/~maywrite/" target="_blank">www.home.earthlink.net/~maywrite/</a></p>
<p class="bk1"></p>
<p class="bkpub">Poisoned Pen Press</p>
<p><img alt="Image" src="Images/ppp-logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pppthreeletter002.vue?6a8ef50f